export default {
  "blockStyleSpacing": "-y0Ax",
  "codeBlock": "MX5cE -y0Ax",
  "renderedInTable": "bUrLq"
};